import { api } from '../../../services/api/apiClient';
import { crudService } from '../../../services/api/crudService';
import type { ApiResponse } from '../../../types/api';
import type { DocPayment } from '../../invoices/types/invoiceTypes';
import type { Purchase, PurchaseEditInput, PurchaseInput } from '../types/purchaseTypes';

const base = crudService<Purchase, PurchaseInput>('/purchases');

export const purchaseService = {
  list: base.list,
  get: base.get,
  create: base.create,
  /** Bill number, date, photo and notes only. */
  update: (id: string, body: Partial<PurchaseEditInput>) => api.patch<ApiResponse<Purchase>>(`/purchases/${id}`, body).then((r) => r.data),
  cancel: (id: string, reason: string) => api.post<ApiResponse<Purchase>>(`/purchases/${id}/cancel`, { reason }).then((r) => r.data),
  payments: (id: string) => api.get<ApiResponse<DocPayment[]>>(`/purchases/${id}/payments`).then((r) => r.data),
};
